import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { paddingV } from "../constants";
import SvgLine from "./SvgLine";
import { BsArrowRight } from "react-icons/bs";
import { keyframes } from "styled-components";
import emailjs from "@emailjs/browser";

const Contact = () => {
	const form = useRef();
	const [controls, setControls] = useState([]);
	const color = useSelector((state) => state.colorSlice.value);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [subject, setSubject] = useState("");
	const [content, setContent] = useState("");
	const [message, setMessage] = useState(false);
	useEffect(() => {
		const con = Array.from(form.current.children);
		const inputs = [];
		con.forEach((c) => {
			if (c.localName === "div") inputs.push(c.children[1]);
		});
		setControls(inputs);
	}, []);
	controls.forEach((i) => {
		i.addEventListener("focus", () => {
			i.previousElementSibling.classList.add("active");
			i.nextElementSibling.children[0].classList.add("active");
			setMessage(false);
		});
		i.addEventListener("blur", () => {
			if (i.value === "") {
				i.previousElementSibling.classList.remove("active");
				i.nextElementSibling.children[0].classList.remove("active");
			}
		});
	});
	const handleSubmit = (e) => {
		e.preventDefault();
		emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_PUBLIC_KEY).then(
			(result) => console.log(result.text),
			(err) => console.log(err.text)
		);
		setName("");
		setEmail("");
		setSubject("");
		setContent("");
		controls.forEach((i) => {
			i.previousElementSibling.classList.remove("active");
			i.nextElementSibling.children[0].classList.remove("active");
		});
		setMessage(true);
	};
	return (
		<Container>
			<Details>
				<h1>Get in Touch</h1>
			</Details>
			<Form method="POST" onSubmit={handleSubmit} ref={form} color={color}>
				<FromControl>
					<p>Name</p>
					<input onChange={(e) => setName(e.target.value)} value={name} name="name" type="text" autoComplete="off" required />
					<SvgLine />
				</FromControl>
				<FromControl>
					<p>Email</p>
					<input onChange={(e) => setEmail(e.target.value)} value={email} name="email" type="email" autoComplete="off" required />
					<SvgLine />
				</FromControl>
				<FromControl>
					<p>Subject</p>
					<input onChange={(e) => setSubject(e.target.value)} value={subject} name="subject" type="text" autoComplete="off" required />
					<SvgLine />
				</FromControl>
				<FromControl>
					<p>Content</p>
					<input onChange={(e) => setContent(e.target.value)} value={content} name="content" type="text" autoComplete="off" required />
					<SvgLine />
				</FromControl>
				<button type="submit">
					Send
					<BsArrowRight />
				</button>
				{message && <p className="message">Send Successfully</p>}
			</Form>
		</Container>
	);
};

export default Contact;

const Container = styled.div`
	height: calc(100vh - ${paddingV} - ${paddingV});
	display: flex;
	flex-direction: column;
`;
const Details = styled.div`
	flex-grow: 0.1;
	margin-top: 3rem;
	display: grid;
	place-items: center;
	h1 {
		font-size: 300%;
		margin: 0;
		padding: 0;
	}
`;
const arrowAnimate = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(10px);
  }
  100% {
    transform: translateX(0);
  }
`;
const Form = styled.form`
	flex-grow: 1;
	padding: 2rem;
	p.active {
		color: ${(props) => props.color};
	}
	button {
		background-color: transparent;
		font-size: 1.2rem;
		cursor: pointer;
		padding: 7px 10px;
		width: 100px;
		border: 1px solid ${(props) => props.color};
		background-color: transparent;
		display: flex;
		align-items: center;
		justify-content: space-between;
		transition: all 0.5s ease;
		border-radius: 0.6rem;
		color: ${(props) => props.color};
		margin-bottom: 1.2rem;
		svg {
			fill: ${(props) => props.color};
			transition: all 0.5s ease;
		}
		&:hover {
			color: white;
			background-color: ${(props) => props.color};
			padding-right: 14px;
			svg {
				fill: white;
				animation: ${arrowAnimate} 1s ease-in-out infinite;
			}
		}
	}
	.message {
		color: #00ff00;
		font-size: 1rem;
		position: relative;
		transform: translateY(-3.4rem) translateX(7rem);
		display: inline-block;
	}
`;
const FromControl = styled.div`
	position: relative;
	height: 4rem;
	margin-bottom: 2rem;
	p {
		position: absolute;
		top: 2px;
		left: 0;
		font-size: 1.5rem;
		color: #fff;
		z-index: 1;
		pointer-events: none;
		transition: all 0.3s ease-out 480ms;
		&.active {
			font-size: 1rem;
			top: -10px;
		}
	}
	input {
		width: 100%;
		border: none;
		background-color: transparent;
		width: 100%;
		height: 100%;
		position: absolute;
		bottom: 0;
		left: 0;
	}
`;
